import { Box, Grid2, Typography } from "@mui/material";
import PrimaryIcon from "Components/Common/PrimaryIcon";
import PrimarySlider from "Components/Common/PrimarySlider";
import React, { useState } from "react";
import { SwiperSlide } from "swiper/react";
import { ReactComponent as CalendarIcon } from "Assets/Icons/Home/CalendarIcon.svg";
import { useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";

const styles = (theme) => ({
  border: `1px solid ${theme.palette.border.blue}`,
  borderRadius: "8px",
  padding: "16px",
  "& .classBox": {
    cursor: "pointer",
    border: `1px solid ${theme.palette.border.blue}`,
    borderRadius: "8px",
    padding: "16px",
    display: "flex",
    flexDirection: "column",
    gap: "10px",
  },
  "& .active": {
    background: theme.palette.primary.main,
    "& p, span": {
      color: theme.palette.white.main,
    },
    "& svg": {
      fill: theme.palette.white.main,
    },
  },
});

const ClassList = () => {
  const navigate = useNavigate();
  const { id, sessionId = 0 } = useParams();

  const { Modules, Translation } = useSelector((state) => ({
    Modules: state.Course.modules,
    Translation: state.Translation.translation?.Course || {},
  }));

  return (
    <Grid2 sx={styles}>
      <PrimarySlider
        slidesPerView={{
          1200: { slidesPerView: 4 },
          900: { slidesPerView: 4 },
          600: { slidesPerView: 2 },
          0: { slidesPerView: 1 },
        }}
        spacing={"15px"}
      >
        {Modules[id]?.Sessions?.map((item, i) => {
          return (
            <SwiperSlide key={i}>
              <Grid2
                key={`class${i}`}
                className={`classBox ${sessionId == i ? "active" : ""}`}
                // onClick={() => navigate(`/class/${i}`)}
                onClick={() => navigate(`/session/${id}/${i}`)}
              >
                <Box display={"flex"} flexDirection={"column"} gap={"6px"}>
                  <Typography
                    className="title"
                    variant="subtitle"
                    fontWeight={500}
                  >
                    {`${Translation?.Day} ${item.Day} - ${item.ScheduleName}`}
                  </Typography>
                  {/* <Typography className="info" color="secondary.light">
                    Product Strategy & Business Acumen
                  </Typography> */}
                  <Typography
                    display={"flex"}
                    alignItems={"center"}
                    gap="5px"
                    variant="body2"
                    color="secondary.light"
                  >
                    <PrimaryIcon icon={CalendarIcon} />
                    {/* Tue, 21 Nov 2023 */}
                    { new Intl.DateTimeFormat('en-GB', {
                        weekday: 'short',
                        day: '2-digit',
                        month: 'short',
                        year: 'numeric',
                      }).format(new Date(item.StartDate))
                    }
                  </Typography>
                </Box>
              </Grid2>
            </SwiperSlide>
          );
        })}
      </PrimarySlider>
    </Grid2>
  );
};

export default ClassList;
